import { Module } from 'vuex';
import { UserInfo } from './user-info.interface';
import { UserInfoService } from './user-info.service';

const service = new UserInfoService();

export interface UserInfoState {
   userInfo?: UserInfo;
   loadingUserInfo: boolean;
}

const UserInfoStore: Module<UserInfoState, any> = {
   namespaced: true,
   state: { loadingUserInfo: true, userInfo: undefined },
   getters: {},
   mutations: {
      SET_USER_INFO(state, userInfo?: UserInfo) {
         state.userInfo = userInfo;
      },
      SET_LOADING_USER_INFO(state: UserInfoState, loading: boolean) {
         state.loadingUserInfo = loading;
      },
   },
   actions: {
      async getUserInfo(context) {
         context.commit('SET_LOADING_USER_INFO', true);

         return await service
            .getUserInfo()
            .then((userInfo) => {
               context.commit(
                  'setPowerBiTokens',
                  userInfo.power_bi_tokens?.map((token: any) => token.token),
                  { root: true }
               );

               context.commit('SET_USER_INFO', userInfo);
               context.commit('setPermissions', userInfo.scopes, { root: true });
               context.commit('setPolicyKeys', userInfo.policy_keys, { root: true });
               context.commit('setRoles', userInfo.roles, { root: true });
               return userInfo;
            })
            .finally(() => {
               context.commit('SET_LOADING_USER_INFO', false);
            });
      },
      async patchUser(context, body) {
         return await service.patchUser(body, context.state.userInfo!.id).then((response) => {
            context.commit('SET_USER_INFO', { ...context.state.userInfo, ...response });
         });
      },
      async getUsers(context, query) {
         return await service.getUsers(query).then((response) => {
            return response;
         });
      },
   },
};

export default UserInfoStore;
